import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import Button from '../../baseComponents/gui/button/Button';
import { useModal } from '../../../hooks/useModal';
import useStateControls from '../../../hooks/useStateControls';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';

const LeaveModal = React.forwardRef(function LeaveModal({ continueFunc, backFunc, setState }, ref) {
  const { setPrevState } = useStateControls();
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  return (
    <CustomModal
      className={'custom-modal_pause'}
      animation={['fade', 'scale', 'scale-bounce']}
      styles={'height:'}
      horizontalPosition={''}
    >
      <div className={'leave-modal'} ref={ref}>
        <div className='leave-modal__bg' />
        <div className='leave-modal__content'>
          <h2 className={'leave-modal__title'}>{safeHTML(t('leaveModalContent.title'))}</h2>
          <Button
            className={`leave-modal__button button_green`}
            onClick={() => {
              backFunc?.();
              setState?.();
              !setState && setPrevState();
              closeModal({ id });
            }}
          >
            {t('leaveModalContent.buttons.0.text')}
          </Button>
          <Button
            className={`leave-modal__button custom-button_gray`}
            onClick={() => {
              continueFunc?.();
              closeModal({ id });
            }}
          >
            {t('leaveModalContent.buttons.1.text')}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
});
export default LeaveModal;
LeaveModal.propTypes = {};
